import React from 'react';

const Validation = ({data, field, cls, style}) => {
  const field_parts = field.split('.');
  const first_part = field_parts[0];
  const last_part = field_parts[1];

  if (data) {
    const method = data ? data[Object.keys(data)[0]] : null;

    if (method.errors) {
      const {errors} = method;
      for (let i in errors) {
        if (errors[i].field === first_part) {
          const messages = errors[i].messages;
          if (!last_part) {
            if (messages.includes('User with this username already exists.')) {
              return (
                <div className={`font-2 text-danger mt-1 ${cls}`} style={style}>
                  Вы зарегистрировались, нажмите Логин и введите ваши данные
                </div>
              );
            }
            return <div className={`font-2 text-danger mt-1 ${cls}`}>{messages}</div>;
          }
          if (messages.includes(last_part)) {
            if (last_part === 'image') {
              return (
                <div className={`font-2 text-danger mt-1 ${cls}`} style={style}>
                  Wrong format. Must be jpg or png.
                </div>
              );
            }
            return (
              <div className={`font-2 text-danger mt-1 ${cls}`} style={style}>
                This field may not be blank.
              </div>
            );
          }
        }
      }
    }
  }

  return null;
};

export default Validation;
